import React,{useContext} from "react";
import SherbetWhite from "../../styles/images/png/sherbetWhite.png"
import { Box, Grid, Link, Typography, Container, IconButton } from '@mui/material';
import { FacebookIcon,TwitterIcon , VimeoIcon, YoutubeIcon } from "../../styles/images/svg/SocialMediaIcons";
import { UiSubscribeNow } from "./SubscribeNow";
import {Context} from "../../_context/Store";
import SherbetFooterLogo from "../../styles/images/sherbt-footer-logo.png"

export const Footer = (props) => {

  const [state, dispatch] = useContext(Context);

    return (
        <div className="sbt-footer">
          <div className="sbt-footer__curve"></div>
          <div className="sbt-footer-top-wr" style={state.ui_sidebar_open ? { width: '70%', marginLeft:'380px'} : { width: '85%', marginLeft:'128px'}}>
            <UiSubscribeNow/>
            {/* <Grid container spacing={2} justifyContent="space-between" className="sbt-footer__first-row">
              <Grid container spacing={4}  >
                <Grid item ><span>Points</span></Grid>
                <Grid item ><span>Why Sherbet</span></Grid>
                <Grid item ><span>Reviews</span></Grid>
                <Grid item ><span>Help</span></Grid>
              </Grid>
              <Grid container spacing={2}  justifyContent="flex-end">
                <Grid item ><FacebookIcon/></Grid>
                <Grid item ><TwitterIcon/></Grid>
                <Grid item ><VimeoIcon/></Grid>
                <Grid item ><YoutubeIcon/></Grid>
              </Grid>
            </Grid> */}
            <Grid container spacing={2} justifyContent={"space-between"} className="sbt-footer__second-row">
              <Grid item md={2}  >
                <p>Email Us</p>
                <a href = "mailto: support@sherbet.com">support@sherbet.com</a>
              </Grid>
              <Grid item md={2} >
                <p>Call Us</p>
                <a href = "tel:00012345678">+44 (0) 20 7605 4500</a>
              </Grid>
              <Grid item md={5}>
                <div className="sbt-footer__second-row__logo">                 
                  <img src={SherbetFooterLogo}/></div>
              </Grid>
              <Grid item md={3} className="sbt-footer__second-row-terms">
                <div><span>Terms of Service</span><span>Privacy Policy</span></div>
                <label>© 2024 Sherbet. All rights reserved.</label>
              </Grid>
            </Grid>
          </div>
         </div>
    )
}
